import styles from './NavBar.module.css'
import { Link } from 'react-router-dom';
import logo from '../../img/Sicap.png'


function NavBar () {
  return (
    <>
    <header className={styles.cabecalho}>
                <Link to="/">
                  <img src={logo} alt="Logo do site" className={styles.image}/>
                </Link>
                <nav className={styles.navbar}>
                    <Link to="/" className={styles.item} style={{ color: 'inherit' }}>Home</Link>
                    <Link to="/guiadousuario" className={styles.item} style={{ color: 'inherit' }}>Guia Do Usuário</Link>
                    <Link to="/dicas" className={styles.item} style={{ color: 'inherit' }}>Dicas</Link>
                    <Link to="/sobre" className={styles.item} style={{ color: 'inherit' }}>Sobre</Link>
                    <Link to="/login" className={styles.item} style={{ color: 'inherit' }}>Entrar</Link>
                   
                </nav>
      </header>
  </>
  )
}

export default NavBar;